import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import ArtworkCard from "./ArtworkCard";
import Slider from "./Slider";

function Result(props) {
  // props.distance = 0;
  // Declare a new state variable, which we'll call "count"
  //const [count, setCount] = useState(0);
  const items = props.gameData;
  const round = props.round;
  const delay = props.distance > 0 ? 1 : 0.5;
  const isNotSmall = window.matchMedia(
    "screen and (min-width: 30em)"
  ).matches;
  let resultText = "Almost"
  if(props.score < 20) resultText = props.i18n.oops // "Oops"
  else if(props.score > 20 && props.score<50) resultText = props.i18n.not_quite // "Not quite"
  else if(props.score>= 50 && props.score < 75) resultText = props.i18n.good // "Good"
  else if(props.score > 75) resultText =  props.i18n.amazing // "Amazing"
  let currItem = items[Object.keys(items)[round]];
  return (
    <motion.div
      className="w-80-ns w-90 h-100 center custom-light pb0-ns pb3"
      initial={
        isNotSmall ? { x: "150%", opacity: 0 } : { y: "-150%", opacity: 0 }
      }
      exit={{opacity:0}}
      animate={isNotSmall ? { x: "0%", opacity: 1 } : { y: "0%", opacity: 1 }}
      transition={{
        opacity: { duration: isNotSmall ? 0.8 : 0  },
        duration:isNotSmall? 0.45 : 0,
        delay: isNotSmall ?0.5 : 0 ,
        ease: "easeOut"
      }}
    >
      <div className="flex flex-column-ns flex-row justify-between justify-center-ns">
        <div className="mr0-ns mr2 pr2">
          <h1 className="normal mt0 pt3 db-ns dn">{resultText}!</h1>
          <p className="f6 mt2-ns mt4 pb0 mb2">{props.i18n.your_guess_was}</p>
          
          
          {props.distance > 0 ? (
            <div>
            <p className="f2 ma0 pa0 mb2">
            <CountUp delay={delay} end={Math.round(props.distance)} duration={1} />
            km
          </p>
          <p className="f6 ma0 pa0 mb2">{props.i18n.away_from_location}</p>
          </div>
          ): 
          <div>
            <p className="f4 ma0 pa0 mb2">{props.i18n.exactly_right_location}</p>
          </div>}
          
          {currItem.category === "streetview" ? null : (
            <p className="f4-ns f5 ma0 pa0 mb4-ns mb2 measure">
              {currItem.address}
            </p>
          )}
        </div>
        <div className="tl-ns pt2">
          <p className="f6 mt2-ns mt4 pb0 mb2">{props.i18n.you_earned}</p>
          <p className="f2 ma0 pa0 mb2">
            <CountUp delay={delay*2} end={props.score} />
          </p>
          <p className="f6 ma0 pa0 mb4-ns mb2">{props.i18n.points}</p>
          <button
              className="bg-custom-light custom-dark dn db-ns"
              onClick={() => {
                props.nextRound();
              }}
            >
              {props.round < props.numRounds - 1
                ? props.i18n.next_round
                : props.i18n.see_score}
            </button>
        </div>
      </div>

      <Slider score={props.score} delay={delay*2} />
      {isNotSmall ? (
        <ArtworkCard
          gameData={props.gameData}
          round={props.round}
          displayMoreInfo={props.displayMoreInfo}
        />
      ) : null}
    </motion.div>
  );
}

export default Result;
